function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { selx } from "clsx";
import { jsx } from "panel";
import moment from "moment";
import { ExperimentalModalEl } from "common/components/modal";
import { CustomAlertEl } from "common/widgets/alerts/custom-alert";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { InputEl } from "common/components/input";
import { LastUpdatedEl } from "common/components/last-updated";
import { ControlBarEl } from "common/widgets/control-bar";
import { SharingStatusButtonEl } from "common/widgets/sharing/status-button";
import { BoardsSaveButtonEl } from "common/query-builder/query-report-header/boards-save-menu";
import { ConfirmEl } from "common/components/confirm";
import { TableEl } from "common/components/table";
import { THEME as confirmTheme } from "common/components/confirm/types";
import { SearchDisplayContext } from "common/report/util/search/types";
import { SIZE, TEXT_HIGHLIGHT_THEME, TextHighlightEl } from "common/components/text-highlight";
import { TooltipEl } from "common/components/tooltip";
import { Placement, TooltipTextAlign } from "common/components/tooltip/types";
import { KEY_VALUES } from "common/util/dom";
import { MAX_REPORT_DESCRIPTION_LENGTH } from "common/constants";
import { CreatorWithViewsIcon, OnlineUsers } from "common/widgets/user-list/presets";
import { SwitchEl } from "common/components/switch";
import { TooltipTourEl } from "common/components/tooltip-tour";
import { TourName } from "common/components/tooltip-tour/types";
import { userColumnProps } from "common/widgets/table-column/user";
import { BreadcrumbsEl, BreadcrumbsTheme } from "common/components/breadcrumbs";
import { getReportUrl } from "common/report/util";
import { LinkNodeStyle } from "common/components/breadcrumbs/types";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerColor, SpinnerSize } from "common/components/spinner/types";
import { SelectEl } from "common/components/select";
import { SelectTheme } from "common/components/select/constants";
import { Directions } from "common/components/drop-menu/types";
import { colors } from "common/util/colors";
import { generateShortcutLabel } from "common/util/keyboard";
import { HeaderAction, REPORT_HEADER_HEIGHT } from "./types";
import styles from "./index.module.styl";
import { SubscribeToBoardsMenuEl } from "./subscribe-to-boards-menu";
import { DigestTrackingEvent, track } from "./subscribe-to-boards-menu/tracking";
import { DIGEST_COPY } from "./subscribe-to-boards-menu/constants";
export function AlertModal(_ref) {
  let {
    cmp
  } = _ref;
  const displayContext = cmp.params.displayContext;
  const isReportValid = [SearchDisplayContext.Insights, SearchDisplayContext.Funnels].includes(displayContext);
  if (cmp.state.isCreateAlertModalOpen && isReportValid) {
    return /* @__PURE__ */ jsx(ExperimentalModalEl, { sel: selx(styles.alertModal), attrs: {
      open: true,
      closeable: true,
      "grow-to-content": true,
      "hide-close-button": true
    }, on: {
      change: (ev) => ev.detail.state === "closed" && cmp.helpers.closeCustomAlertModal()
    } }, /* @__PURE__ */ jsx(CustomAlertEl, { attrs: {
      "bookmark-id": cmp.params.selectedEntityId,
      "enable-condition-types": cmp.params.enableCustomAlertConditionTypes,
      "is-editing-mode": false,
      "project-id": cmp.params.projectId,
      "workspace-id": cmp.params.workspaceId,
      "report-type": displayContext,
      "results-keys-and-values": cmp.params.resultsKeysAndValues,
      "time-unit": cmp.params.customAlertTimeUnit,
      "date-range-interval-days": cmp.params.customAlertIntervalDays,
      "is-anomaly-detection-control-disabled": !cmp.params.enableAnomalyDetectionControls,
      "bookmark-params": cmp.params.bookmarkParams
    }, on: {
      cancel: cmp.helpers.closeCustomAlertModal,
      create: cmp.helpers.handleCustomAlertCreated,
      error: cmp.helpers.handleCustomAlertError
    } }));
  }
  return null;
}
const AddDescriptionButton = (_ref2) => {
  let {
    description,
    placeholder,
    on,
    canEdit
  } = _ref2;
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderBoardsEditDescriptionButton), attrs: {
    title: description,
    elref: "boardsDescription"
  }, class: {
    [styles.canEdit]: canEdit
  }, on: _objectSpread({}, on), "data-sentry-component": "AddDescriptionButton", "data-sentry-source-file": "template.tsx" }, description || "+ ".concat(placeholder, "..."), description && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: description,
    "max-width": "250px",
    "break-word": true
  } }));
};
const ViewOnlyBadge = (_ref3) => {
  let {
    viewOnlyHighlightMarkdown,
    isReportModeEnabled,
    onViewOnlyBadgeClicked
  } = _ref3;
  return /* @__PURE__ */ jsx("span", { sel: selx(styles.mpQueryReportHeaderBadge), "data-sentry-component": "ViewOnlyBadge", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(TextHighlightEl, { attrs: {
    elref: "viewOnlyHighlight",
    markdown: viewOnlyHighlightMarkdown,
    size: SIZE.MEDIUM,
    theme: TEXT_HIGHLIGHT_THEME.GENERIC
  }, on: !isReportModeEnabled && {
    click: () => onViewOnlyBadgeClicked === null || onViewOnlyBadgeClicked === void 0 ? void 0 : onViewOnlyBadgeClicked()
  }, "data-sentry-element": "TextHighlightEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: isReportModeEnabled ? "You have view only access. To keep report changes, save as new." : "You do not have permission to edit this board.  Click to view current permissions.",
    "max-width": "200px"
  }, "data-sentry-element": "TooltipEl", "data-sentry-source-file": "template.tsx" }));
};
const PublicDashboardBadge = (props) => {
  return /* @__PURE__ */ jsx("span", { sel: selx(styles.mpQueryReportHeaderBadge), "data-sentry-component": "PublicDashboardBadge", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(TextHighlightEl, { attrs: {
    elref: "publicDashboardTextHighlight",
    text: "Public",
    size: SIZE.MEDIUM,
    theme: TEXT_HIGHLIGHT_THEME.INFORMATION
  }, "data-sentry-element": "TextHighlightEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Right,
    "max-width": "233px",
    offset: 10
  }, "data-sentry-element": "TooltipEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", null, "Public Boards are accessible to anyone with a URL. People outside your project will see see a read-only version."), /* @__PURE__ */ jsx("br", null), /* @__PURE__ */ jsx("div", { sel: ".view-public-links", on: {
    click: (ev) => {
      ev.preventDefault();
      props.clickHandler();
    }
  }, style: {
    color: colors.gray3,
    cursor: "pointer",
    textDecoration: "underline"
  } }, "View public links for this Board"))));
};
const DraftBadge = () => {
  return /* @__PURE__ */ jsx("span", { sel: selx(styles.mpQueryReportHeaderBadge), "data-sentry-component": "DraftBadge", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(TextHighlightEl, { attrs: {
    elref: "viewOnlyHighlight",
    text: "Draft",
    size: SIZE.MEDIUM,
    theme: TEXT_HIGHLIGHT_THEME.FAILED
  }, "data-sentry-element": "TextHighlightEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: "This Mixpanel board is currently a draft of a template. While in draft mode you cannot edit the board or add to the board until you\u2019ve completed setting up the template.",
    "max-width": "200px"
  }, "data-sentry-element": "TooltipEl", "data-sentry-source-file": "template.tsx" }));
};
const ReportInput = (_ref4) => {
  let {
    value,
    onInputChanged,
    onEditStop
  } = _ref4;
  return /* @__PURE__ */ jsx(InputEl, { attrs: {
    "select-on-focus": true,
    elref: "boardsHeaderInput"
  }, props: {
    value
  }, on: {
    blur: (ev) => onInputChanged === null || onInputChanged === void 0 ? void 0 : onInputChanged(ev.target.value),
    keydown: (ev) => {
      if (ev.key === KEY_VALUES.ESCAPE) {
        ev.preventDefault();
        onEditStop === null || onEditStop === void 0 || onEditStop();
      } else if (ev.key === KEY_VALUES.ENTER) {
        ev.preventDefault();
        onInputChanged === null || onInputChanged === void 0 || onInputChanged(ev.target.value);
      }
    }
  }, hook: {
    insert: (vnode) => {
      requestAnimationFrame(() => {
        vnode.elm.focus();
      });
    }
  }, "data-sentry-element": "InputEl", "data-sentry-component": "ReportInput", "data-sentry-source-file": "template.tsx" });
};
const EditDescriptionInput = (_ref5) => {
  let {
    cmp
  } = _ref5;
  return /* @__PURE__ */ jsx(ReportInput, { value: cmp.helpers.getReportDescription(), onInputChanged: (value) => {
    const prevDescription = cmp.helpers.getReportDescription();
    const truncatedDescription = value.substring(0, MAX_REPORT_DESCRIPTION_LENGTH);
    cmp.update({
      isEditingDescription: false,
      newReportDescription: truncatedDescription
    });
    if (!cmp.hasSelectedEntity) {
      cmp.dispatchEvent(new CustomEvent("editreport", {
        detail: {
          description: truncatedDescription
        }
      }));
    }
    if (prevDescription !== cmp.state.newReportDescription) {
      cmp.autoSaveNameAndDescription();
    }
  }, onEditStop: () => cmp.update({
    isEditingDescription: false
  }), "data-sentry-element": "ReportInput", "data-sentry-component": "EditDescriptionInput", "data-sentry-source-file": "template.tsx" });
};
const reportTitleLoadingIndicator = () => {
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderBreadcrumbLoading), "data-sentry-component": "reportTitleLoadingIndicator", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(SpinnerEl, { sel: selx(styles.spinner), attrs: {
    color: SpinnerColor.Inherit,
    size: SpinnerSize.Small
  }, "data-sentry-element": "SpinnerEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("span", { sel: selx(styles.mpQueryReportHeaderBreadcrumbLoadingText) }, "Saving"));
};
const BreadcrumbsTitle = (_ref6) => {
  let {
    currentProject,
    dashboardsRoute,
    homePage,
    id,
    isEditingTitle,
    title,
    projectId,
    workspaceId,
    canEdit,
    maskReportName,
    onTitleChanged,
    onTitleClicked
  } = _ref6;
  let linkNodes = [];
  if (currentProject) {
    let tooltipText = currentProject.name;
    const workspace = currentProject.workspaces[workspaceId];
    if (workspace) {
      tooltipText = "".concat(tooltipText, "\n").concat(workspace.name);
    }
    linkNodes.push({
      label: currentProject.name,
      tooltip: {
        text: tooltipText,
        "max-width": "250px",
        "break-word": true,
        "text-align": TooltipTextAlign.Start
      },
      value: null,
      style: LinkNodeStyle.Secondary
    });
  }
  if (homePage) {
    linkNodes.push({
      label: homePage.title,
      value: null,
      url: homePage.url
    });
  }
  linkNodes = linkNodes.concat(dashboardsRoute.filter((board) => board.title).map((board) => ({
    label: board.title,
    value: null,
    url: getReportUrl("boards#id=".concat(board.id), {
      projectId,
      workspaceId
    })
  })));
  linkNodes.push({
    label: maskReportName ? "" : title,
    value: id,
    isInEditMode: isEditingTitle,
    disabled: maskReportName
  });
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderBreadcrumb), "data-sentry-component": "BreadcrumbsTitle", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(BreadcrumbsEl, { attrs: {
    theme: BreadcrumbsTheme.Path,
    editable: canEdit,
    elref: "headerBreadcrumb"
  }, props: {
    linkNodes
  }, style: {
    "min-width": "0"
  }, on: {
    nodeClick: (ev) => {
      const linkNode = ev.detail.node;
      if (linkNode.value === id) {
        onTitleClicked === null || onTitleClicked === void 0 || onTitleClicked();
      }
    },
    nodeUpdated: (ev) => {
      const newNode = ev.detail.node;
      if (newNode.value === id) {
        onTitleChanged === null || onTitleChanged === void 0 || onTitleChanged(newNode.label);
      }
    }
  }, "data-sentry-element": "BreadcrumbsEl", "data-sentry-source-file": "template.tsx" }), maskReportName && reportTitleLoadingIndicator());
};
const ReportsHeaderTitle = (_ref7) => {
  let {
    cmp
  } = _ref7;
  return /* @__PURE__ */ jsx(null, null, cmp.state.isEditingDescription ? /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderBoardsBreadcrumbBox) }, !cmp.state.isEditingTitle && /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderEditDescriptionBox) }, /* @__PURE__ */ jsx(EditDescriptionInput, { cmp }))) : /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderBoardsBreadcrumbBox) }, /* @__PURE__ */ jsx(BreadcrumbsTitle, { currentProject: cmp.getCurrentProject(), dashboardsRoute: cmp.params.dashboardsRoute || [], homePage: cmp.params.homePage, title: cmp.helpers.getTitle(), id: cmp.params.selectedEntityId, isEditingTitle: cmp.state.isEditingTitle, displayContext: cmp.params.displayContext, projectId: cmp.params.projectId, workspaceId: cmp.params.workspaceId, canEdit: cmp.canEditExistingEntity(), maskReportName: cmp.isSavingAsNew, onTitleChanged: (newTitle) => cmp.handleReportTitleChanged(newTitle), onTitleClicked: () => cmp.helpers.handleEditReportName() }), cmp.helpers.showViewOnlyTextHighlight() && /* @__PURE__ */ jsx(ViewOnlyBadge, { viewOnlyHighlightMarkdown: cmp.helpers.viewOnlyHighlightMarkdown(), isReportModeEnabled: cmp.helpers.isReportModeEnabled() }), cmp.canEditExistingEntity() && !cmp.state.isEditingTitle && !cmp.isSavingAsNew && /* @__PURE__ */ jsx(AddDescriptionButton, { description: cmp.helpers.getReportDescription(), placeholder: cmp.t("reports.header.description-placeholder"), on: {
    click: () => {
      var _cmp$helpers$handleEd, _cmp$helpers;
      return (_cmp$helpers$handleEd = (_cmp$helpers = cmp.helpers).handleEditReportDescription) === null || _cmp$helpers$handleEd === void 0 ? void 0 : _cmp$helpers$handleEd.call(_cmp$helpers);
    }
  }, canEdit: true })));
};
const BoardsHeaderTitle = (_ref8) => {
  let {
    cmp
  } = _ref8;
  const canEdit = cmp.canEditExistingEntity();
  const computedAt = cmp.params.computedAt;
  const samplingNotice = cmp.helpers.getSamplingNotice({
    isReportModeEnabled: false
  });
  const isPublicDashboard = cmp.params.isPublicDashboard || cmp.state.showPublicBadge;
  const isTemplateDashboard = cmp.params.isTemplateDashboard;
  const isTemplateDraftDashboard = cmp.params.isTemplateDraftDashboard;
  const isDashboardModeEnabled = cmp.isDashboardModeEnabled();
  return /* @__PURE__ */ jsx("div", { class: {
    [styles.dashboardsBoardUi]: isDashboardModeEnabled
  }, "data-sentry-component": "BoardsHeaderTitle", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderTitleTextContainer) }, /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderBoardsBreadcrumbBox) }, /* @__PURE__ */ jsx(BreadcrumbsTitle, { currentProject: cmp.getCurrentProject(), dashboardsRoute: cmp.params.dashboardsRoute || [], homePage: cmp.params.homePage, title: cmp.helpers.getTitle(), id: cmp.params.selectedEntityId, isEditingTitle: cmp.state.isEditingTitle, displayContext: cmp.params.displayContext, projectId: cmp.params.projectId, workspaceId: cmp.params.workspaceId, canEdit, maskReportName: false, onTitleChanged: (value) => {
    cmp.submitSave({
      newReportData: {
        name: value
      }
    });
  }, onTitleClicked: () => cmp.helpers.handleEditReportName(), "data-sentry-element": "BreadcrumbsTitle", "data-sentry-source-file": "template.tsx" }), cmp.helpers.showViewOnlyTextHighlight() && /* @__PURE__ */ jsx(ViewOnlyBadge, { viewOnlyHighlightMarkdown: cmp.helpers.viewOnlyHighlightMarkdown(), isReportModeEnabled: cmp.helpers.isReportModeEnabled(), onViewOnlyBadgeClicked: () => cmp.helpers.handleSharingStatusButtonClick() }), isTemplateDraftDashboard && /* @__PURE__ */ jsx(DraftBadge, null), isPublicDashboard && /* @__PURE__ */ jsx(PublicDashboardBadge, { clickHandler: cmp.helpers.handleViewPublicDashboardLinksClick }), isTemplateDashboard && cmp.helpers.isFreePlan() && /* @__PURE__ */ jsx("span", { sel: selx(styles.mpQueryReportHeaderBadge) }, /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    elref: "templateDashboardFreePlanTooltip",
    text: "Your plan includes 5 reports. The reports in this template don't count towards that limit until you modify and save them.",
    placement: Placement.RightCenter
  } }), /* @__PURE__ */ jsx(TextHighlightEl, { attrs: {
    elref: "templateDashboardTextHighlight",
    text: "Mixpanel Template",
    size: SIZE.MEDIUM,
    theme: TEXT_HIGHLIGHT_THEME.NEUTRAL,
    "style-override": '.mp-text-highlight.neutral {font-family: "Apercu Pro", "Helvetica Neue", Helvetica, Tahoma, Geneva, Arial, sans-serif;}'
  } })), /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderMetadata) }, computedAt ? /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderLastUpdated) }, /* @__PURE__ */ jsx(LastUpdatedEl, { params: {
    isCompact: false,
    lastRefreshDate: computedAt,
    refreshIntervalMs: cmp.params.autoRefreshIntervalMs
  }, on: {
    refresh: cmp.helpers.handleAutoRefresh
  } })) : null, samplingNotice ? /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderSamplingNotice) }, samplingNotice) : null)), isDashboardModeEnabled && cmp.params.boardsTitleBadgeEl));
};
const HeaderActions = (props) => {
  var _cmp$helpers$getBoard;
  const cmp = props.cmp;
  const controlBarActions = /* @__PURE__ */ jsx(ControlBarEl, { params: _objectSpread({
    theme: ButtonTheme.Tertiary,
    overflowMenuWidth: 220,
    overflowTooltip: {
      text: cmp.helpers.getHeaderActionOverflowTooltip()
    },
    controls: cmp.getHeaderActionItems(),
    overflowControls: cmp.getHeaderActionOverflowItems(),
    onActionSelect: cmp.helpers.onHeaderActionClick,
    // this is to update the refresh's sublabel to the latest time
    onOverflowMenuClick: cmp.helpers.onOverflowMenuClick
  }, cmp.helpers.isDashboardModeEnabled() || cmp.helpers.isReportModeEnabled() ? {
    overflowMenuHeight: 500,
    styleOverride: ".mp-control-bar .mp-control-bar-control {margin-right: 12px;}"
  } : {}) }, /* @__PURE__ */ jsx("div", { attrs: {
    slot: "subscribe"
  } }, /* @__PURE__ */ jsx(SelectEl, { attrs: _objectSpread({
    label: cmp.t("boards.actions.subscribe"),
    icon: {
      leftIcon: "feed"
    },
    open: cmp.state.subscribeMenuOpen,
    "menu-alignment": Directions.DownRight,
    "prevent-close": true,
    // We have a nested confirm modal that closes this otherwise
    theme: SelectTheme.Tertiary
  }, cmp.canAccessDigests() ? {} : {
    disabled: true,
    tooltip: {
      text: cmp.getContext("i18n").print(DIGEST_COPY.missingPermissions)
    }
  }), on: {
    menuChange: (event) => {
      if (event.detail.isOpen) {
        track(DigestTrackingEvent.OpenSubscribeButtonMenu);
      }
      cmp.update({
        subscribeMenuOpen: event.detail.isOpen
      });
    }
  } }, /* @__PURE__ */ jsx("div", { attrs: {
    slot: "body"
  }, sel: selx(styles.subscribeMenu) }, cmp.params.selectedEntityId && cmp.params.projectId && !cmp.isMetricTreeModeEnabled() && !cmp.isExperimentModeEnabled() && !cmp.isFeatureFlagModeEnabled() && !cmp.isHeatMapModeEnabled() ? /* @__PURE__ */ jsx(SubscribeToBoardsMenuEl, { dashboardId: cmp.params.selectedEntityId, isOpen: cmp.state.subscribeMenuOpen, onCloseCallback: () => cmp.update({
    subscribeMenuOpen: false
  }), projectId: cmp.params.projectId, projectTimezone: cmp.helpers.getProjectTimezone(), workspaceId: cmp.params.workspaceId }) : null))), /* @__PURE__ */ jsx("div", { attrs: {
    slot: "createdBy"
  } }, cmp.params.onlineUsers ? /* @__PURE__ */ jsx(OnlineUsers, { userListSel: selx(styles.createdBy), trackingProps: cmp.getPresenceTrackingProps(), onlineUsers: cmp.params.onlineUsers, entityEditor: cmp.params.selectedEntityEditor, entityCreator: cmp.params.selectedEntityCreator, presenceViews: cmp.state.presenceViews }) : /* @__PURE__ */ jsx(CreatorWithViewsIcon, { userListSel: selx(styles.createdBy), trackingProps: cmp.getPresenceTrackingProps(), entityEditor: cmp.params.selectedEntityEditor, entityCreator: cmp.params.selectedEntityCreator, presenceViews: cmp.state.presenceViews, totalPresenceViews: cmp.state.totalPresenceViews })), cmp.helpers.showShareButton() ? /* @__PURE__ */ jsx(SharingStatusButtonEl, { attrs: {
    elref: "reportShareButton",
    disabled: !cmp.helpers.isShareButtonEnabled(),
    "hide-share-button": cmp.helpers.isReportModeEnabled(),
    id: cmp.params.selectedEntityId,
    "is-select": false,
    "project-id": cmp.params.projectId,
    theme: cmp.helpers.getShareButtonTheme(),
    "tooltip-text": !cmp.helpers.isReportModeEnabled() && cmp.helpers.getShareTooltipText(),
    type: cmp.helpers.getSharableEntityType(),
    slot: "sharing"
  }, props: {
    extraTrackingParams: cmp.extraTrackingParams
  }, on: {
    share: cmp.helpers.isShareButtonEnabled() ? cmp.helpers.handleSharingStatusButtonClick : null
  } }) : null, cmp.params.isQuerySamplingActionVisible ? /* @__PURE__ */ jsx("span", { attrs: {
    slot: "toggle-query-sampling"
  } }, /* @__PURE__ */ jsx(SwitchEl, { attrs: {
    disabled: Boolean(cmp.params.querySamplingDisabledMessage),
    on: cmp.params.isQuerySamplingEnabled,
    icon: "sampling",
    showcase: cmp.params.triggerQuerySamplingTourTooltip,
    "show-icon-while-off": true,
    slot: "toggle-query-sampling",
    elref: "querySamplingDisabledSwitch"
  }, on: {
    change: (ev) => cmp.helpers.handleToggleQuerySampling(ev.detail)
  } }), cmp.params.triggerQuerySamplingTourTooltip ? /* @__PURE__ */ jsx(TooltipTourEl, { params: {
    uniqueTourName: TourName.QueryTimeSampling,
    showDoNotShowCheckbox: true,
    title: cmp.t("sampling.query-sampling.enable"),
    markdownText: cmp.t("sampling.query-sampling.description"),
    primaryButtonLabel: cmp.t("sampling.query-sampling.confirm"),
    secondaryButtonLabel: cmp.t("common.learn-more"),
    onPrimaryButtonClick: () => {
      cmp.dispatchEvent(new CustomEvent("actionclick", {
        detail: {
          value: HeaderAction.DismissQuerySamplingTour
        }
      }));
    },
    onSecondaryButtonBlick: () => window.open("https://docs.mixpanel.com/docs/analysis/advanced/other-advanced-features#query-time-sampling", "_blank")
  } }) : null) : null, cmp.params.headerActionItemsEl);
  const closeReportShortcut = generateShortcutLabel("Esc", {
    forMarkdown: true
  });
  const cancelSaveReportButton = /* @__PURE__ */ jsx("div", { sel: selx(styles.boardsHeaderAction) }, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Tertiary,
    elref: "boardsCancelButton",
    tooltip: {
      text: "".concat(cmp.t("reports.actions.close-tooltip"), " ").concat(closeReportShortcut),
      placement: Placement.Bottom
    }
  }, on: {
    click: cmp.helpers.handleBoardButtonClick
  } }, cmp.t("reports.actions.close")));
  const boardsMainDashboardId = (_cmp$helpers$getBoard = cmp.helpers.getBoardsMainDashboard()) === null || _cmp$helpers$getBoard === void 0 ? void 0 : _cmp$helpers$getBoard.id;
  const saveReportButton = /* @__PURE__ */ jsx("div", { sel: selx(styles.boardsHeaderAction) }, /* @__PURE__ */ jsx(BoardsSaveButtonEl, { params: {
    selectedDashboardId: boardsMainDashboardId,
    userId: cmp.params.userId,
    canSaveExisting: !cmp.isSaveButtonDisabled(),
    canSaveAsNew: !cmp.isSaveAsNewButtonDisabled(),
    tooltip: !cmp.params.isSavingBookmark && cmp.getSaveTooltipText(),
    elref: "boardsSaveButton",
    alignRight: true,
    searchPlaceholder: cmp.t("reports.actions.saving.save-to-board-placeholder"),
    isSaving: cmp.params.isSavingBookmark,
    hasUnsavedChanges: cmp.hasUnsavedChanges,
    hasExistingReport: cmp.hasSelectedEntity,
    showSaveSpinner: cmp.params.isSavingBookmark && !cmp.isSavingAsNew,
    onMenuChange: cmp.helpers.handleBoardsSaveMenuChange,
    onSave: (_ref9) => {
      let {
        saveMode,
        dashboardId
      } = _ref9;
      return cmp.helpers.saveReportToDashboard(saveMode, dashboardId || boardsMainDashboardId);
    }
  }, props: {
    dashboardController: cmp.dashboardController,
    recentDashboardIds: cmp.getRecentlyViewedDashboards()
  } }));
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderActions), "data-sentry-component": "HeaderActions", "data-sentry-source-file": "template.tsx" }, cmp.helpers.isDashboardModeEnabled() ? /* @__PURE__ */ jsx(null, null, controlBarActions) : cmp.helpers.isReportModeEnabled() ? /* @__PURE__ */ jsx("div", { sel: selx(styles.boardsExtraActions) }, controlBarActions, /* @__PURE__ */ jsx("div", { sel: selx(styles.gapLine) }), cmp.showAvailableDashboardsDropdown() && cancelSaveReportButton, saveReportButton) : controlBarActions);
};
const SaveWarningModal = (_ref10) => {
  let {
    cmp
  } = _ref10;
  return /* @__PURE__ */ jsx(ConfirmEl, { attrs: {
    theme: confirmTheme.CONFIRM,
    "confirm-button-label": "Save changes",
    open: cmp.state.showSaveWarningModal,
    closeable: true
  }, style: {
    width: "700px"
  }, on: {
    submit: cmp.helpers.saveWarningModalSubmitted,
    change: cmp.helpers.saveWarningModalChanged
  }, "data-sentry-element": "ConfirmEl", "data-sentry-component": "SaveWarningModal", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-title" }, "Save Report Changes"), /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-description" }, cmp.helpers.getEditWarning()), /* @__PURE__ */ jsx(TableEl, { on: {
    cellClick: cmp.helpers.handleSaveWarningTableCellCliked
  }, style: {
    "margin-top": "20px"
  }, attrs: {
    "default-sort-field": "name",
    "empty-message": "You do not have any alerts.",
    "max-body-height": "300px",
    "style-override": ".mp-table {border: 1px solid var(--gray1); border-radius: 12px; overflow: hidden;}"
  }, props: {
    rows: cmp.customAlertsForSelectedBookmark.map((customAlert) => {
      var _customAlert$creator;
      return {
        name: customAlert === null || customAlert === void 0 ? void 0 : customAlert.name,
        creator: customAlert === null || customAlert === void 0 || (_customAlert$creator = customAlert.creator) === null || _customAlert$creator === void 0 ? void 0 : _customAlert$creator.name,
        created: moment.utc(customAlert === null || customAlert === void 0 ? void 0 : customAlert.created).local()
      };
    }),
    columns: [{
      title: "Name",
      field: "name",
      isSearchable: true,
      isSortable: true,
      flexGrow: "3",
      type: "text-link"
    }, Object.assign({
      title: "Created by",
      field: "creator",
      isSearchable: true,
      isSortable: true,
      flexGrow: "4",
      type: "user"
    }, userColumnProps), {
      field: "created",
      title: "Created",
      flexGrow: "3",
      isSortable: true,
      sortTransform: (row) => row.created.unix(),
      labelTransform: (row) => row.created.format("MMM D, YYYY")
    }]
  }, "data-sentry-element": "TableEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Secondary,
    href: cmp.params.duplicateReportUrl,
    target: "_blank"
  }, style: {
    position: "relative",
    top: "56px"
  }, on: {
    click: () => cmp.trackDuplicateButtonClick()
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Save as new report")));
};
export function template() {
  const isReportModeEnabled = this.helpers.isReportModeEnabled();
  const {
    showSaveWarningModal
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeader), class: {
    [styles.boardsMode]: isReportModeEnabled,
    [styles.disableHeaderMargin]: this.params.disableHeaderMargin
  }, style: {
    "--header-height": "".concat(REPORT_HEADER_HEIGHT, "px")
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.helpers.isHeaderReady() ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQueryReportHeaderBar) }, isReportModeEnabled ? /* @__PURE__ */ jsx(ReportsHeaderTitle, { cmp: this }) : /* @__PURE__ */ jsx(BoardsHeaderTitle, { cmp: this }), /* @__PURE__ */ jsx(HeaderActions, { cmp: this }))) : null, /* @__PURE__ */ jsx(AlertModal, { cmp: this, "data-sentry-element": "AlertModal", "data-sentry-source-file": "template.tsx" }), showSaveWarningModal ? /* @__PURE__ */ jsx(SaveWarningModal, { cmp: this }) : null);
}
